import { useMutation, useQueryClient } from '@tanstack/react-query';
import { confirmPcmpProposalDisbursement } from '../api/pcmpProposals.api';
import type { PcmpDisbursementConfirmPayload } from '../types/pcmpProposal.types';
import { pcmpActionCallbacks } from '../utils/pcmpActionCallbacks';

/** The submitting MO confirms an Accounts payout (LDS-747). */
export function useConfirmPcmpDisbursement(proposalId: number, onSuccess: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PcmpDisbursementConfirmPayload) =>
      confirmPcmpProposalDisbursement(proposalId, payload),
    ...pcmpActionCallbacks(queryClient, 'Disbursement confirmed', onSuccess),
  });
}
